export default [
  {
    path: "/home",
    name: "home",
    label: "Início",
    component: () => import("@/components/home/Home.vue"),
  },
];
